var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreasuresBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 371,
    height: 346,
    viewBox: "0 0 371 346",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4516_467527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.5 70L191.039 140.706L221.367 76.7367L197.579 143.415L250.079 95.9211L202.585 148.421L269.263 124.633L205.294 154.961L276 158.5L205.294 162.039L269.263 192.367L202.585 168.579L250.079 221.079L197.579 173.585L221.367 240.263L191.039 176.294L187.5 247L183.961 176.294L153.633 240.263L177.421 173.585L124.921 221.079L172.415 168.579L105.737 192.367L169.706 162.039L99 158.5L169.706 154.961L105.737 124.633L172.415 148.421L124.921 95.9211L177.421 143.415L153.633 76.7367L183.961 140.706L187.5 70Z",
    fill: "#FFD0A0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_4516_467527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.5 -13L192.089 123.643L231.887 -7.15628L200.954 126.019L273.25 9.97664L208.903 130.608L308.769 37.2312L215.392 137.097L336.023 72.75L219.981 145.046L353.156 114.113L222.357 153.911L359 158.5L222.357 163.089L353.156 202.887L219.981 171.954L336.023 244.25L215.392 179.903L308.769 279.769L208.903 186.392L273.25 307.023L200.954 190.981L231.887 324.156L192.089 193.357L187.5 330L182.911 193.357L143.113 324.156L174.046 190.981L101.75 307.023L166.097 186.392L66.2312 279.769L159.608 179.903L38.9766 244.25L155.019 171.954L21.8437 202.887L152.643 163.089L16 158.5L152.643 153.911L21.8437 114.113L155.019 145.046L38.9766 72.75L159.608 137.097L66.2312 37.2312L166.097 130.608L101.75 9.97664L174.046 126.019L143.113 -7.15628L182.911 123.643L187.5 -13Z",
    fill: "#F8B890"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4516_467527",
    x: 83,
    y: 54,
    width: 209,
    height: 209,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_4516_467527"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_4516_467527",
    x: 0,
    y: -29,
    width: 375,
    height: 375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_4516_467527"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreasuresBg);
export default __webpack_public_path__ + "static/media/treasures-bg.6988d3d1117c825fc330aadf8a67b1b5.svg";
export { ForwardRef as ReactComponent };